import e from "../node_modules/.pnpm/@mx_fsp-mweb-collector@0.125.0/node_modules/@mx/fsp-mweb-collector/dist/index.esm.js";
var o = new e({
  defaultCategory: "fsp_dcep",
  defaultCid: "",
  appName: "com.sankuai.fspfepayresource.ecny.component",
  lxCommonParams: {}
});
export { o as lx };
